var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_4_253",
    "data-name": "Component 4 \\u2013 253",
    xmlns: "http://www.w3.org/2000/svg",
    width: 170.706,
    height: 24,
    viewBox: "0 0 180.706 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_572",
    "data-name": "Path 572",
    d: "M4496.3,1361.153h-6.469v20.988h2.919v-7.869h3.331c4.755,0,7.593-2.467,7.593-6.6S4500.987,1361.153,4496.3,1361.153Zm-.219,10.724h-3.331v-8.328h3.413c3.034,0,4.508,1.349,4.508,4.125C4500.672,1370.423,4499.087,1371.877,4496.082,1371.877Z",
    transform: "translate(-4489.832 -1358.159)",
    fill: "#ddd6c5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_811",
    "data-name": "Rectangle 811",
    width: 2.92,
    height: 20.987,
    transform: "translate(22.57 2.993)",
    fill: "#ddd6c5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_573",
    "data-name": "Path 573",
    d: "M4527.958,1363.362l.037-.049v-2.16h-15.019v2.584h11.264l-11.666,16.2-.034.049v2.16h15.673v-2.584h-11.892Z",
    transform: "translate(-4476.796 -1358.159)",
    fill: "#ddd6c5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M4543.659,1363.362l.034-.049v-2.16h-15.017v2.584h11.267l-11.67,16.2-.034.049v2.16h15.672v-2.584h-11.892Z",
    transform: "translate(-4467.778 -1358.159)",
    fill: "#ddd6c5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M4551.047,1361.153l-7.565,20.988h2.942l2.162-6.143h8.086l2.184,6.143h3.106l-7.644-20.988Zm1.571,3.249v-.009c.154.5.408,1.307.677,2.075l2.534,7.134h-6.407l2.512-7.134C4552.2,1365.708,4552.464,1364.891,4552.618,1364.4Z",
    transform: "translate(-4459.028 -1358.159)",
    fill: "#ddd6c5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M4576.41,1361.212h-3.039l-9.523,13.671v2.24h9.74v4.985h2.821v-4.985h2.725v-2.534h-2.725Zm-9.373,13.4,5.579-8.017c.446-.649.765-1.19.973-1.567v9.584Z",
    transform: "translate(-4447.332 -1358.127)",
    fill: "#ddd6c5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M4585.84,1361.153h-6.474v20.988h2.922v-7.869h3.333c4.753,0,7.588-2.467,7.588-6.6S4590.521,1361.153,4585.84,1361.153Zm-.218,10.724h-3.333v-8.328h3.414c3.032,0,4.508,1.349,4.508,4.125C4590.21,1370.423,4588.624,1371.877,4585.622,1371.877Z",
    transform: "translate(-4438.419 -1358.159)",
    fill: "#ddd6c5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M4590.787,1365.554h2.1l2.643-6.328h-3.47Z",
    transform: "translate(-4431.863 -1359.226)",
    fill: "#ddd6c5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M4604.736,1370.318l-2.864-.5c-2.273-.425-3.244-1.364-3.244-3.144,0-1.987,1.593-3.27,4.058-3.27a3.729,3.729,0,0,1,4.035,3.555l.021.164h2.89l-.012-.2c-.2-3.709-2.72-5.835-6.905-5.835-4.162,0-7.067,2.383-7.067,5.793,0,3.059,1.865,4.955,5.546,5.632l2.843.5c2.248.378,3.293,1.385,3.293,3.169,0,2.432-1.554,3.665-4.615,3.665-3.931,0-4.725-2.727-4.884-3.9l-.022-.163h-2.945l.014.2c.229,3.825,3.212,6.2,7.783,6.2,4.813,0,7.571-2.264,7.571-6.212C4610.23,1372.787,4608.486,1370.99,4604.736,1370.318Z",
    transform: "translate(-4429.524 -1358.191)",
    fill: "#ddd6c5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ad27dd5.svg";
export { ForwardRef as ReactComponent };